import React from "react";
import SimpleModal from "../Modal";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import {
  // @ts-expect-error
  copy,
  learnMore,
  modalTitle,
  modalSubtitle,
  benefits,
  // @ts-expect-error
  benefitsInfo,
  benefitsTitle,
  benefitsBody,
  icons,
  disclaimer
} from "./shopPay.module.scss";
import { Typography, useMediaQuery } from "@material-ui/core";
import { MOBILE_BREAKPOINT } from "../../utils/constants";

const ShopPayWidget = ({
  price,
  width = "100%",
  shortCopy = false
}: {
  price: number | null;
  width?: string | number;
  shortCopy?: boolean;
}) => {
  const modalTrigger = (
    <button className={`${learnMore} button-as-link`}>
      <u>Learn more</u>
    </button>
  );
  const paymentAmount = price ? (price / 4).toFixed(2) : null;

  const widgetCopy = shortCopy
    ? "Shop now, pay later with "
    : `Pay in full or in 4 interest-free installments${
        paymentAmount ? " of $" + paymentAmount : ""
      } with `;

  const modalCopy = `Choose Shop Pay at checkout to split your purchase into 4 equal installments${
    paymentAmount ? " of" : ""
  }`;

  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);

  return (
    <div style={{ width }}>
      <Typography variant="caption" className={`${copy} widget-copy`}>
        {widgetCopy}
      </Typography>
      <SimpleModal trigger={modalTrigger} width={600} ariaLabel="shop-pay-info">
        <div style={isMobile ? { padding: "15px" } : { padding: "20px 50px" }}>
          <h3 className={`${modalTitle}`}>
            Pay now or later - it's up to you.
          </h3>
          <h4 className={`${modalSubtitle}`}>
            {modalCopy}
            {paymentAmount && (
              <span
                style={{
                  color: "var(--dark-green)",
                  fontWeight: 700,
                  opacity: 1,
                  fontSize: "larger",
                  lineHeight: 1
                }}
              >
                {" "}
                {paymentAmount}*.
              </span>
            )}
          </h4>

          <div className={`${benefits}`}>
            <div className={icons}>
              <MoneyOffIcon
                fontSize="large"
                style={{ color: "var(--dark-pink)" }}
              />
            </div>
            <div className={`${benefitsInfo}`}>
              <h5 className={benefitsTitle}>No hidden fees</h5>
              <p className={benefitsBody}>
                No interests, no fees, and no impact to your credit score.
              </p>
            </div>
          </div>
          <div className={`${benefits}`}>
            <div className={icons}>
              <CreditCardIcon
                fontSize="large"
                style={{ color: "var(--dark-pink)" }}
              />
            </div>
            <div className={`${benefitsInfo}`}>
              <h5 className={benefitsTitle}>Make the most of your budget</h5>
              <p className={benefitsBody}>
                Automatic payments every two weeks on your debit card keep
                things flexible.
              </p>
            </div>
          </div>
          <p className={disclaimer}>
            *Subject to eleigibiity check and approval. Estimated payment amount
            excludes taxes and shipping fees.
          </p>
          <img
            src="https://cdn.shopify.com/s/files/1/1540/8825/files/shop-pay_1.svg?v=1629669757"
            alt="Shop Pay"
            className={`img-fluid`}
            style={{ width: 120, margin: "0 auto", display: "flex" }}
          />
        </div>
      </SimpleModal>
    </div>
  );
};

export default ShopPayWidget;
